import { useScrollReveal } from '@/hooks/useScrollReveal';

const WHATSAPP_URL = 'https://wa.me/918861133745?text=Hi%2C%20I%27m%20interested%20in%20Confident%20Auriga.%20Please%20share%20more%20details.';
const BOOK_VISIT_URL = 'https://wa.me/918861133745?text=Hi%2C%20I%20would%20like%20to%20book%20a%20site%20visit%20at%20Confident%20Auriga.%20Please%20share%20available%20dates%20and%20timings.';

export default function ContactSection() {
  useScrollReveal('.contact-reveal', 0.1);

  return (
    <section className="py-12 md:py-20 bg-primary relative overflow-hidden">
      {/* Subtle dot-grid background */}
      <div className="absolute inset-0 opacity-[0.04]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        />
      </div>

      <div className="section-padding relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-8 md:mb-12">
          <div className="contact-reveal scroll-reveal">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/10 border border-white/20 rounded-full font-body text-[10px] md:text-xs tracking-[0.2em] uppercase text-white/80">
              <span className="w-1.5 h-1.5 bg-gold rounded-full animate-pulse" />
              Get In Touch
            </span>
          </div>
          <h2 className="contact-reveal scroll-reveal font-display text-2xl md:text-4xl lg:text-5xl text-white font-bold mt-4 md:mt-5 leading-tight">
            Contact <span className="text-gold">Us</span>
          </h2>
          <p className="contact-reveal scroll-reveal font-body text-sm md:text-base text-white/60 mt-3 md:mt-4 leading-relaxed max-w-lg mx-auto">
            Reach our team directly for immediate assistance with site visits, pricing, and investment details for premium plots near Bangalore at Confident Auriga Malur.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-4xl mx-auto">
          {/* Phone */}
          <div className="contact-reveal scroll-reveal bg-white/[0.06] backdrop-blur-xl border border-white/[0.08] rounded-2xl p-6 md:p-7 text-center hover:-translate-y-1.5 hover:border-gold/20 transition-all duration-500 group">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-white/5 flex items-center justify-center mx-auto mb-4 group-hover:bg-gold/10 transition-colors duration-500">
              <i className="ri-phone-line text-gold text-xl md:text-2xl"></i>
            </div>
            <h3 className="font-display text-sm md:text-base text-white font-semibold mb-1">Phone</h3>
            <p className="font-body text-lg md:text-xl text-gold font-medium tracking-wide mb-4">88611 33745</p>
            <a
              href="tel:+918861133745"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-white/10 backdrop-blur-md border border-white/20 text-white font-body text-xs tracking-wider uppercase rounded-full transition-all duration-500 hover:bg-gold hover:text-primary hover:border-gold whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              Call Now
            </a>
          </div>

          {/* WhatsApp */}
          <div className="contact-reveal scroll-reveal bg-white/[0.06] backdrop-blur-xl border border-white/[0.08] rounded-2xl p-6 md:p-7 text-center hover:-translate-y-1.5 hover:border-gold/20 transition-all duration-500 group">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-white/5 flex items-center justify-center mx-auto mb-4 group-hover:bg-gold/10 transition-colors duration-500">
              <i className="ri-whatsapp-line text-gold text-xl md:text-2xl"></i>
            </div>
            <h3 className="font-display text-sm md:text-base text-white font-semibold mb-1">WhatsApp</h3>
            <p className="font-body text-sm md:text-base text-white/70 mb-4">Quick Response</p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-[#25D366] hover:bg-[#1faa52] text-white font-body text-xs tracking-wider uppercase rounded-full transition-all duration-500 hover:scale-[1.02] active:scale-[0.98] whitespace-nowrap shadow-lg shadow-[#25D366]/20"
            >
              <i className="ri-whatsapp-line"></i>
              WhatsApp Us
            </a>
          </div>

          {/* Book Visit */}
          <div className="contact-reveal scroll-reveal bg-white/[0.06] backdrop-blur-xl border border-white/[0.08] rounded-2xl p-6 md:p-7 text-center hover:-translate-y-1.5 hover:border-gold/20 transition-all duration-500 group">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-white/5 flex items-center justify-center mx-auto mb-4 group-hover:bg-gold/10 transition-colors duration-500">
              <i className="ri-calendar-check-line text-gold text-xl md:text-2xl"></i>
            </div>
            <h3 className="font-display text-sm md:text-base text-white font-semibold mb-1">Book Visit</h3>
            <p className="font-body text-sm md:text-base text-white/70 mb-4">Schedule a Tour</p>
            <a
              href={BOOK_VISIT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-gold hover:bg-gold-light text-primary font-body text-xs tracking-wider uppercase rounded-full transition-all duration-500 hover:scale-[1.02] active:scale-[0.98] whitespace-nowrap shadow-lg shadow-gold/20"
            >
              <i className="ri-calendar-check-line"></i>
              Book Now
            </a>
          </div>
        </div>

        {/* Address bar */}
        <div className="contact-reveal scroll-reveal mt-8 md:mt-10 max-w-xl mx-auto">
          <div className="bg-white/[0.04] backdrop-blur-md border border-white/[0.06] rounded-xl px-5 py-3.5 flex items-center justify-center gap-3">
            <i className="ri-map-pin-line text-gold text-lg"></i>
            <p className="font-body text-xs md:text-sm text-white/70 tracking-wide text-center">
              4W46+8JM, Promenade Rd, Thornahalli, Karnataka 563130
            </p>
          </div>
        </div>

        {/* Google Maps Button */}
        <div className="contact-reveal scroll-reveal mt-4 md:mt-5 max-w-xl mx-auto flex justify-center">
          <a
            href="https://maps.app.goo.gl/4hfVwUuwC5W5ASWn6?g_st=ac"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2.5 px-7 py-3 bg-[#D4B06A] text-[#0D2B1F] font-body font-semibold text-sm tracking-wider rounded-xl transition-all duration-500 hover:bg-[#c2a05a] hover:shadow-lg hover:shadow-[#D4B06A]/20 hover:-translate-y-0.5 active:scale-[0.98] whitespace-nowrap"
          >
            <i className="ri-map-2-line text-base"></i>
            Open in Google Maps
          </a>
        </div>
      </div>
    </section>
  );
}